import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { logoimages } from "../data/logoimages";

// import dreamlandLogo from "../assets/logos/webp/dreamland.webp";
// import miranshLogo from "../assets/logos/webp/miransh.webp";
// import shreelilaLogo from "../assets/logos/webp/shrileela.webp";
// import dreamlandHorizontal from "../assets/logos/webp/dreamland hori.webp";

import { Helmet } from "react-helmet";

const  dreamlandLogo = logoimages.logos.landingpage.dreamlandLogo
 const miranshLogo =  logoimages.logos.landingpage.miranshLogo
 const  shreelilaLogo =  logoimages.logos.landingpage.shreelilaLogo
 const  dreamlandHorizontal=  logoimages.logos.landingpage.dreamlandHorizontal

const COLORS = {
  navy: "#0F1F3D",
  gold: "#D4A017",
  light: "#F8FAFC",
  text: "#0F1F3D",
  muted: "#64748B",
};

const HOTELS = [
  {
    id: "dreamland-inn",
    name: "Dreamland Inn",
    type: "Signature Beach Resort",
    tag: "Our Flagship",
    cardImage: dreamlandLogo,
    glow: "rgba(20, 100, 155, 0.28)",
    borderGradient: "linear-gradient(160deg, #5BA8D4 0%, #14649B 35%, #4A96C8 55%, #14649B 75%, #0D4D7A 100%)",
  },
  {
    id: "miransh-heavenly",
    name: "Miransh Heavenly",
    type: "Luxury Cliff Retreat",
    tag: "Premium",
    cardImage: miranshLogo,
    glow: "rgba(51, 126, 129, 0.24)",
    borderGradient: "linear-gradient(160deg, #6DBFC2 0%, #337E81 35%, #5AB0B3 55%, #337E81 75%, #235759 100%)",
  },
  {
    id: "shree-lila",
    name: "Shrileela",
    type: "Boutique Stay",
    tag: "Warm & Welcoming",
    cardImage: shreelilaLogo,
    glow: "rgba(64, 80, 56, 0.24)",
    borderGradient: "linear-gradient(160deg, #7A9468 0%, #405038 35%, #6A8459 55%, #405038 75%, #2C3827 100%)",
  },
];

const GoldOrnament = () => (
  <svg width="72" height="16" viewBox="0 0 72 16" fill="none">
    <line x1="0" y1="8" x2="24" y2="8" stroke="#C8960C" strokeWidth="0.8" opacity="0.7" />
    <circle cx="28" cy="8" r="2" fill="#C8960C" opacity="0.75" />
    <circle cx="36" cy="8" r="3" fill="#C8960C" opacity="0.9" />
    <circle cx="44" cy="8" r="2" fill="#C8960C" opacity="0.75" />
    <line x1="48" y1="8" x2="72" y2="8" stroke="#C8960C" strokeWidth="0.8" opacity="0.7" />
  </svg>
);

const GoldDivider = () => (
  <svg
    width="160"
    height="14"
    viewBox="0 0 160 14"
    fill="none"
    style={{ margin: "4px auto 0", display: "block" }}
  >
    <line x1="0" y1="7" x2="58" y2="7" stroke="#C8960C" strokeWidth="0.8" opacity="0.5" />
    <circle cx="65" cy="7" r="1.8" fill="#C8960C" opacity="0.7" />
    <path d="M73 3.5 L76 7 L73 10.5" stroke="#C8960C" strokeWidth="1" fill="none" opacity="0.8" />
    <circle cx="80" cy="7" r="2.8" fill="#C8960C" opacity="0.9" />
    <path d="M87 3.5 L84 7 L87 10.5" stroke="#C8960C" strokeWidth="1" fill="none" opacity="0.8" />
    <circle cx="95" cy="7" r="1.8" fill="#C8960C" opacity="0.7" />
    <line x1="102" y1="7" x2="160" y2="7" stroke="#C8960C" strokeWidth="0.8" opacity="0.5" />
  </svg>
);

const OvalCard = ({ hotel, index, onClick }) => (
  <motion.div
    initial={{ opacity: 0, y: 60, scale: 0.88 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    transition={{ duration: 1, delay: 0.2 + index * 0.14, ease: [0.23, 1, 0.32, 1] }}
    onClick={onClick}
    whileHover={{ y: -12, scale: 1.03 }}
    whileTap={{ scale: 0.97 }}
    style={{ cursor: "pointer" }}
  >
    {/* Outer border shell — pill shape */}
    <div
      style={{
        width: "240px",
        height: "400px",
        borderRadius: "9999px",
        padding: "3px",
        background: hotel.borderGradient,
      }}
    >
      {/* Inner card — same pill shape */}
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "9999px",
          overflow: "hidden",
          background: "linear-gradient(180deg, #FFFFFF 0%, #FAF6EE 100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingTop: "52px",
          paddingBottom: "52px",
          paddingLeft: "22px",
          paddingRight: "22px",
          boxSizing: "border-box",
          gap: "10px",
        }}
      >
        <img
          src={hotel.cardImage}
          alt={hotel.name}
          style={{
            width: "76%",
            maxHeight: "148px",
            objectFit: "contain",
            flexShrink: 0,
          }}
          loading="eager"
        />

        <div
          style={{
            marginTop: "2px",
            padding: "4px 14px",
            borderRadius: "9999px",
            background: "transparent",
            border: `1px solid ${COLORS.gold}99`,
            fontSize: "9px",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: COLORS.gold,
            fontWeight: 700,
            whiteSpace: "nowrap",
          }}
        >
          {hotel.tag}
        </div>

        <p
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "20px",
            fontWeight: 500,
            color: COLORS.text,
            textAlign: "center",
            margin: 0,
            lineHeight: 1.2,
          }}
        >
          {hotel.name}
        </p>

        <p
          style={{
            fontSize: "9.5px",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: COLORS.muted,
            fontWeight: 500,
            margin: 0,
            textAlign: "center",
          }}
        >
          {hotel.type}
        </p>

        <div style={{ marginTop: "4px" }}>
          <GoldOrnament />
        </div>
      </div>
    </div>
  </motion.div>
);

// ✅ Receives onHotelSelect from App — no loader state here anymore
export default function LandingPage({ onHotelSelect }) {

  return (
    <div
      style={{
        minHeight: "100vh",
        background: COLORS.light,
        position: "relative",
        overflow: "hidden",
        fontFamily: "'DM Sans', system-ui, sans-serif",
      }}
    >
      <Helmet>
        <title>Dreamland Inn Beach Resort | Best Beach Resort in Kokan</title>
        <meta
          name="description"
          content="Dreamland Inn Beach Resort offers luxury rooms, beach view, AC rooms, and best stay in Kokan. Book now!"
        />
      </Helmet>

      {/* Background orbs */}
      <div style={{ position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none" }}>
        <div style={{
          position: "absolute", width: "700px", height: "700px", borderRadius: "50%",
          background: "radial-gradient(circle, rgba(15,31,61,0.06) 0%, transparent 65%)",
          top: "-180px", left: "-200px",
        }} />
        <div style={{
          position: "absolute", width: "560px", height: "560px", borderRadius: "50%",
          background: "radial-gradient(circle, rgba(212,160,23,0.08) 0%, transparent 70%)",
          top: "60px", right: "-120px",
        }} />
        <div style={{
          position: "absolute", width: "440px", height: "440px", borderRadius: "50%",
          background: "radial-gradient(circle, rgba(42,157,157,0.07) 0%, transparent 70%)",
          bottom: "-60px", left: "50%", transform: "translateX(-50%)",
        }} />
      </div>

      {/* Navigation */}
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        padding: "18px 5vw", display: "flex", justifyContent: "space-between",
        alignItems: "center", background: "rgba(248,250,252,0.93)",
        backdropFilter: "blur(16px)", borderBottom: "1px solid rgba(15,31,61,0.07)",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "11px" }}>
          <img src={dreamlandLogo} alt="Dreamland Inn"
            style={{ width: "50px", height: "50px", objectFit: "contain" }} />
          <span style={{
            fontFamily: "'Playfair Display', serif", fontSize: "18px",
            fontWeight: 500, color: COLORS.navy,
          }}>
            <em style={{ fontStyle: "italic" }}> Dreamland</em>{" "}
            <em style={{ color: COLORS.gold, fontStyle: "italic" }}>Inn</em>
          </span>
        </div>
        <span style={{
          fontSize: "10.5px", letterSpacing: "0em",
          textTransform: "uppercase", color: COLORS.muted,
        }}>
          KONKAN COAST • MAHARASHTRA
        </span>
      </nav>

      {/* Hero */}
      <div style={{
        paddingTop: "108px", paddingBottom: "28px",
        textAlign: "center", position: "relative", zIndex: 2,
      }}>
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          style={{
            fontSize: "11px", letterSpacing: "0.32em", textTransform: "uppercase",
            color: COLORS.gold, fontWeight: 700, marginBottom: "4px",
          }}
        >
          A Family Legacy
        </motion.p>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }}>
          <GoldDivider />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.95, ease: [0.23, 1, 0.32, 1], delay: 0.1 }}
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(50px, 8vw, 90px)", fontWeight: 400,
            lineHeight: 0.93, color: COLORS.navy, marginTop: "14px", marginBottom: "14px",
          }}
        >
          Welcome to{" "}
          <em style={{ color: COLORS.gold, fontStyle: "italic" }}>Konkan</em>
        </motion.h1>

        <div style={{ margin: "30px 0" }} />

        <div style={{ display: "flex", justifyContent: "center" }}>
          <motion.img
            src={dreamlandHorizontal} alt="Dreamland"
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.28, duration: 0.8 }}
            style={{ width: "296px", objectFit: "contain" }}
          />
        </div>

        <div style={{ margin: "20px 0" }} />

        <p style={{
          fontFamily: "'Cormorant Garamond', serif", fontSize: "19px",
          fontStyle: "italic", color: "#475569", maxWidth: "450px",
          margin: "0 auto", lineHeight: 1.6,
        }}>
          Three unique stays. One family. The soul of the Konkan coast.
        </p>
      </div>

      {/* Cards */}
      <div style={{
        display: "flex", justifyContent: "center", alignItems: "center",
        gap: "48px", padding: "16px 5vw 80px", flexWrap: "wrap",
        position: "relative", zIndex: 2,
      }}>
        {HOTELS.map((hotel, i) => (
          <OvalCard
            key={hotel.id}
            hotel={hotel}
            index={i}
            onClick={() => {
              window.scrollTo(0, 0);
              onHotelSelect(hotel);
            }}
          />
        ))}
      </div>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1 }}
        style={{
          textAlign: "center", padding: "36px 20px", color: "#94A3B8",
          fontSize: "10.5px", letterSpacing: "0.26em", textTransform: "uppercase",
          position: "relative", zIndex: 2,
        }}
      >
        Discover • Unwind • Return
      </motion.div>
    </div>
  );
}